import { render, staticRenderFns } from "./userVerificacode.vue?vue&type=template&id=6b96aa2b"
import script from "./userVerificacode.vue?vue&type=script&lang=js"
export * from "./userVerificacode.vue?vue&type=script&lang=js"
import style0 from "~/assets/css/login/userVerifiCode.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports